import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styles: [],
    standalone: false
})
export class HeaderComponent implements OnInit {
  constructor(private router:Router){}

  @Input() title = ''
  @Input() routes :{label:string,route:string}[]= []
  
  ngOnInit(): void {}

}
